var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import React, { PureComponent, createElement } from 'react';
import classNames from 'classnames';
import { Affix as AntAffix, Anchor as AntAnchor } from 'antd';
import raf from 'raf';
import PropTypes from 'prop-types';
import { ComponentsManager } from '@comall-backend-builder/core';
import { services } from '@comall-backend-builder/core'; // 根据不同的配置，显示不同的指示器

var ANCHOR_INK_COMPONENT_NAME = {
  ball: 'AnchorNavigationInkBall',
  line: 'AnchorNavigationInkLine'
}; // 初始化antd的Anchor组件，为了引入样式文件

createElement(AntAnchor);

function getDefaultContainer() {
  return window;
}

function getOffsetTop(element, container) {
  if (!element) {
    return 0;
  }

  if (!element.getClientRects().length) {
    return 0;
  }

  var rect = element.getBoundingClientRect();

  if (rect.width || rect.height) {
    if (container === window) {
      container = element.ownerDocument.documentElement;
      return rect.top - container.clientTop;
    }

    return rect.top - container.getBoundingClientRect().top;
  }

  return rect.top;
}

function easeInOutCubic(t, b, c, d) {
  var cc = c - b;
  t /= d / 2;

  if (t < 1) {
    return cc / 2 * t * t * t + b;
  }

  return cc / 2 * ((t -= 2) * t * t + 2) + b;
}

function scrollTo(id, offsetTop, getContainer, callback) {
  var container = getContainer();
  var scrollTop = container === window ? container.pageYOffset : container.scrollTop;
  var targetElement = document.getElementById(id);

  if (!targetElement) {
    return;
  }

  var eleOffsetTop = getOffsetTop(targetElement, container);
  var targetScrollTop = scrollTop + eleOffsetTop - offsetTop;
  var startTime = Date.now();

  var frameFunc = function frameFunc() {
    var timestamp = Date.now();
    var time = timestamp - startTime;
    var nextScrollTop = easeInOutCubic(time, scrollTop, targetScrollTop, 450);

    if (container === window) {
      window.scrollTo(window.pageXOffset, nextScrollTop);
    } else {
      container.scrollTop = nextScrollTop;
    }

    if (time < 450) {
      raf(frameFunc);
    } else {
      callback();
    }
  };

  raf(frameFunc);
} // 根据滚动位置，返回当前内容对应的锚点id


function getCurrentAnchor(container, items, offsetTop, bounds) {
  var activeLink = '';

  if (typeof document === 'undefined') {
    return activeLink;
  }

  var linkSections = [];
  items && items.length && items.forEach(function (item) {
    var target = document.getElementById(item.id);

    if (target) {
      var top = getOffsetTop(target, container());

      if (top < offsetTop + bounds) {
        linkSections.push({
          link: item.id,
          top: top
        });
      }
    }
  });

  if (linkSections.length) {
    var maxSection = linkSections.reduce(function (prev, curr) {
      return curr.top > prev.top ? curr : prev;
    });
    return maxSection.link;
  }

  return '';
}

var AnchorNavigation = function (_super) {
  __extends(AnchorNavigation, _super);

  function AnchorNavigation(props) {
    var _this_1 = _super.call(this, props) || this;

    _this_1.state = {
      activeLink: ''
    };
    _this_1.handleScroll = _this_1.handleScroll.bind(_this_1);
    _this_1.handleScrollTo = _this_1.handleScrollTo.bind(_this_1);
    _this_1.renderInk = _this_1.renderInk.bind(_this_1);
    _this_1.renderLinks = _this_1.renderLinks.bind(_this_1);
    return _this_1;
  }

  AnchorNavigation.prototype.render = function () {
    var _a = this.props,
        style = _a.style,
        className = _a.className,
        affix = _a.affix,
        offsetTop = _a.offsetTop,
        showInkInFixed = _a.showInkInFixed,
        getContainer = _a.getContainer,
        align = _a.align,
        items = _a.items;
    var props = {
      style: style,
      className: classNames('anchor-container', className)
    };
    var content = React.createElement("div", __assign({}, props, {
      ref: "anchor"
    }), React.createElement("div", {
      className: "ant-anchor-wrapper",
      style: {
        maxHeight: offsetTop ? 'calc(100vh - ' + offsetTop + 'px)' : '100vh'
      }
    }, React.createElement("div", {
      className: classNames('ant-anchor', !affix && !showInkInFixed ? 'fixed' : '')
    }, this.renderInk(), items && items.length ? this.renderLinks() : null)));
    return React.createElement("div", {
      className: 'anchor-navigation-align-' + align
    }, !affix ? content : createElement(AntAffix, {
      offsetTop: offsetTop,
      target: getContainer
    }, content));
  };
  /**
   * 监听滚动
   */


  AnchorNavigation.prototype.componentDidMount = function () {
    var getContainer = this.props.getContainer;
    getContainer().addEventListener('scroll', this.handleScroll, false);
    this.handleScroll();
  };
  /**
   * 取消监听
   */


  AnchorNavigation.prototype.componentWillUnmount = function () {
    var getContainer = this.props.getContainer;
    getContainer().removeEventListener('scroll', this.handleScroll, false);
  };
  /**
   * 滚动
   */


  AnchorNavigation.prototype.handleScroll = function () {
    if (this.animating) {
      return;
    }

    var _a = this.props,
        getContainer = _a.getContainer,
        items = _a.items,
        offsetTop = _a.offsetTop,
        bounds = _a.bounds;
    this.setState({
      activeLink: getCurrentAnchor(getContainer, items, offsetTop, bounds)
    });
  };
  /**
   * 滚动到
   */


  AnchorNavigation.prototype.handleScrollTo = function (id) {
    var _a = this.props,
        offsetTop = _a.offsetTop,
        getContainer = _a.getContainer;
    this.animating = true;
    this.setState({
      activeLink: id
    });

    var _this = this;

    scrollTo(id, offsetTop, getContainer, function () {
      _this.animating = false;
    });
  };
  /**
   * 渲染锚点导航指示器
   */


  AnchorNavigation.prototype.renderInk = function () {
    var inkType = this.props.inkType;
    var activeLink = this.state.activeLink;
    var inkComponent = ANCHOR_INK_COMPONENT_NAME[inkType];
    var component = ComponentsManager.get(inkComponent);
    return createElement(component, {
      anchorNode: this.refs.anchor,
      activeLink: activeLink
    });
  };
  /**
   * 渲染锚点导航目录
   */


  AnchorNavigation.prototype.renderLinks = function () {
    var _this_1 = this;

    var items = this.props.items;
    var activeLink = this.state.activeLink;
    var links = items.map(function (item, index) {
      if (item.privilege) {
        var _a = item.privilege,
            path = _a.path,
            level = _a.level;

        if (!services.privilege.check(path, level)) {
          return undefined;
        }
      }

      return React.createElement("div", {
        className: classNames('ant-anchor-link', activeLink === item.id ? 'ant-anchor-link-active' : ''),
        key: index
      }, React.createElement("a", {
        className: "ant-anchor-link-title",
        onClick: function onClick() {
          return _this_1.handleScrollTo(item.id);
        }
      }, item.name));
    });
    return links;
  };

  AnchorNavigation.defaultProps = {
    affix: true,
    showInkInFixed: false,
    getContainer: getDefaultContainer,
    bounds: 5,
    offsetTop: 0,
    // 默认在右侧
    align: 'right',
    // 默认使用指示点
    inkType: 'ball'
  };
  AnchorNavigation.propTypes = {
    style: PropTypes.object,
    className: PropTypes.string,
    // 是否固定模式
    affix: PropTypes.bool,
    // 非固定模式时，是否显示指示点／指示线
    showInkInFixed: PropTypes.bool,
    // 指定滚动的容器
    getContainer: PropTypes.func,
    // 锚点区域边界
    bounds: PropTypes.number,
    // 距离getContainer顶部达到指定偏移量后触发
    offsetTop: PropTypes.number,
    // 锚点导航位置，默认在右侧
    align: PropTypes.oneOf(['left', 'right']),
    // 指示器／指示点
    inkType: PropTypes.oneOf(['ball', 'line']),
    // 数据
    items: PropTypes.array
  };
  return AnchorNavigation;
}(PureComponent);

export { AnchorNavigation };